import { INTEGRATION_API_PATH } from "~/common/constants/integrations";
import {
  Integration,
  IntegrationType,
  IntegrationUpsert,
} from "~/common/types/integration";
import { api } from "./axios";

export const deleteIntegration = async ({
  organizationId,
  type,
}: {
  organizationId: string;
  type: IntegrationType;
}) => {
  return await api.delete<void>(
    `v1/organizations/${organizationId}/integrations/${INTEGRATION_API_PATH[type]}`,
  );
};

export const getIntegration = async ({
  organizationId,
  integrationType,
}: {
  organizationId: string;
  integrationType: IntegrationType;
}) => {
  const { data } = await api.get<Integration>(
    `v1/organizations/${organizationId}/integrations/${INTEGRATION_API_PATH[integrationType]}`,
  );

  return data;
};

export const listIntegrations = async ({
  organizationId,
}: {
  organizationId: string;
}) => {
  const { data } = await api.get<Integration[]>(
    `v1/organizations/${organizationId}/integrations`,
  );

  return data;
};

export const upsertIntegration = async ({
  integration,
}: {
  integration: IntegrationUpsert;
}) => {
  const { id, organization_id, type, ...payload } = integration;
  const method = id ? api.put<void> : api.post<void>;

  const { data } = await method(
    `v1/organizations/${organization_id}/integrations/${INTEGRATION_API_PATH[type]}`,
    payload,
  );

  return data;
};
